import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { loadRuntimeConfig } from "./config";
import "./index.css";

// Сначала загружаем runtime-конфиг (/config.json), потом монтируем приложение.
// Так api base не вкомпилируется в bundle — OAuth настраивается на сервере.
//
// можно подменять при деплое одного и того же образа в разные среды.
loadRuntimeConfig()
  .then(() => {
    createRoot(document.getElementById("root")!).render(
      <StrictMode>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StrictMode>,
    );
  })
  .catch((err) => {
    // eslint-disable-next-line no-console
    console.error("Failed to load runtime config", err);
    document.getElementById("root")!.innerHTML =
      '<div style="padding:2rem;font-family:sans-serif">' +
      "<h1>Configuration error</h1>" +
      "<p>Не удалось загрузить /config.json. Проверь, что файл существует и доступен.</p>" +
      "</div>";
  });
